import { FetchCandidatesProps } from 'lib/models/candidates';
import { fetchSyncReports } from 'lib/models/syncReport';
import { useCallback, useEffect, useState } from 'react';

function useSyncReports(props: FetchCandidatesProps) {
	const [loading, setLoading] = useState<boolean>(true);
	const [syncReports, setSyncReports] = useState<PaginateSource<PartialAccessOffline>>({ total: 0, elements: [] });

	const refetch = useCallback(async () => {
		const response = await fetchSyncReports(props);
		setSyncReports(response);
		setLoading(false);
	}, [props]);

	useEffect(() => {
		refetch();
	}, [refetch]);

	return { loading, syncReports, refetch, setLoading };
}

export default useSyncReports;
